import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import KeyboardVoiceRoundedIcon from "@mui/icons-material/KeyboardVoiceRounded";
import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import "./styles.css";

const RetakeAudioDialog = ({ isDialogOpen, onClickCancel, onClickRetake }) => {
  const { t, activeLanguage } = useTranslationSetup();

  return (
    <Dialog className="custom-dialog" open={isDialogOpen}>
      <DialogTitle className="retake-audio-dialog-title">
        <Box className="retake-audio-dialog-combined-icon">
          <KeyboardVoiceRoundedIcon className="retake-audio-voice-icon" />
          <CloseOutlinedIcon className="retake-audio-close-icon" />
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box className="retake-audio-dialog-content-text">
          <Typography
            fontSize="20px"
            padding="5px 0 0"
            color="black.deep"
            className="custom-ff-regular"
            lang={activeLanguage}
          >
            {t("retake_audio")}
          </Typography>
          <Typography
            fontSize="14px"
            padding="5px 0 0"
            margin="0 24px 0"
            className="custom-ff-light"
            lang={activeLanguage}
          >
            {t("retake_audio_confirmation_msg")}
          </Typography>

          <Box className="retake-audio-dialog-buttons-container">
            <Button
              className="retake-audio-cancel-button custom-ff-regular"
              variant="text"
              startIcon={<CloseOutlinedIcon />}
              lang={activeLanguage}
              onClick={onClickCancel}
            >
              {t("cancel")}
            </Button>
            <Button
              className="retake-audio-retake-button btn-primary custom-ff-regular"
              lang={activeLanguage}
              variant="contained"
              startIcon={
                <LoopOutlinedIcon className="retake-audio-dialog-loop-icon" />
              }
              onClick={onClickRetake}
              disableElevation
            >
              {t("retake")}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RetakeAudioDialog;
